import * as yup from 'yup';
const userDataValidation = {
  User: yup.object({
    oldPassword: yup.string().required('Password is required'),
    newPassword: yup.string().required('New Password is required'),
    confirmNewPassword: yup
      .string()
      .oneOf(
        [yup.ref('newPassword')],
        'New password and Confirm new password must match'
      )
      .required('Confirm New Password is required'),
  }),
};

export default userDataValidation;
